import * as yup from "yup";

export const yupSchema = {
  profileName: yup
    .string()
    .required("required field")
    .min(1, "you should have at least 1 character"),
  location: yup.string().required(),
};
